<template>
  <div class="lower-container">
    <div class="floor-plan">
      <div class="floor-plan-title">Floor plan</div>
      <div class="radio-buttons-container">
        <custom-radio-button
          label="Seats"
          :value="changeSelectOption === 1"
          @click="changeSelectOption = 1"
        />
        <custom-radio-button
          label="Rows"
          :value="changeSelectOption === 2"
          @click="changeSelectOption = 2"
        />
      </div>
      <div id="spinner-svg-wrapper">
        <div v-if="loadingSvg" id="spinner-container">
          <spinner />
        </div>
        <div style="position: relative">
          <object
            id="svgfile"
            :data="initialVenue.imageUrl"
            type="image/svg+xml"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="seat-state-wrapper">
        <div v-for="data in legend" :key="data.label" class="seat-state">
          <div class="state-logo" :style="data.style" />
          <span>{{ data.label }}</span>
          <p class="count">
            {{ data.count ? data.count() : '' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SeatState } from '@/types'
import * as Hammer from 'hammerjs'
import * as svgPanZoom from 'svg-pan-zoom'
import CustomRadioButton from '../events/custom-radio-button.vue'

export default {
  name: 'gratis-ticket-floor-plan',
  components: {
    CustomRadioButton,
  },
  props: {
    initialVenue: {
      type: Object,
      default: () => {},
    },
    initVenueAvailability: {
      type: Object,
      default: () => {},
    },
    initialValues: {
      type: Object,
    },
  },
  data() {
    return {
      form: this.initialValues || {},
      selectedVenue: this.initialVenue,
      venueAvailability: this.initVenueAvailability,
      eventListenerType: {
        true: 'touchstart',
        false: 'click',
      },
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      loadingSvg: true,
      changeSelectOption: 1,
      legend: [
        {
          label: 'Unavailable',
          style: 'background: #D9D9D9;',
        },
        {
          label: 'Available',
          style: 'background: #4CAF50',
        },
        {
          label: 'Ticket not asssigned',
          style: 'background: #BD0202',
        },
        {
          label: 'Selected',
          style: 'background: white;border: 3px solid #333333;',
          count: function () {
            return this.form.selectedSeats.length + '/' + this.form.initialQuantity
          }.bind(this),
        },
      ],
    }
  },
  mounted() {
    this.handleInitialVenue(this.selectedVenue)
  },
  methods: {
    refreshSeats() {
      this.venueAvailability = this.initVenueAvailability
      const svgDoc = document.getElementById('svgfile').getSVGDocument()
      this.form.selectedSeats.map(s => {
        svgDoc.getElementById(s).removeAttribute('stroke')
        this.colorSeat(svgDoc, s)
      })
      this.form.selectedSeats = this.form.selectedSeats.filter(s => {
        return this.venueAvailability[s] && this.venueAvailability[s].state === SeatState.AVAILABLE
      })
    },
    handleInitialVenue() {
      setTimeout(() => {
        this.hammerInit()
        const svgDoc = document.getElementById('svgfile').getSVGDocument()
        this.initializeVenueMap(svgDoc)
        svgDoc.getElementById('svg-pan-zoom-controls').remove()
        this.loadingSvg = false
        document.getElementById('spinner-svg-wrapper').style.height = 'fit-content'
      }, 1000)
    },
    initializeVenueMap(svgDoc) {
      this.selectedVenue.seats.map(s => {
        const initSeatState = this.venueAvailability && this.venueAvailability[s]
        if (initSeatState) {
          this.colorSeat(svgDoc, s, true)
        }
        if (this.venueAvailability[s] === undefined) {
          this.venueAvailability[s] = { ticketAssigned: false }
        }

        if (
          !initSeatState ||
          (initSeatState &&
            initSeatState.state !== SeatState.HOLD &&
            initSeatState.state !== SeatState.SOLD &&
            initSeatState.state !== SeatState.DISABLED)
        ) {
          svgDoc.getElementById(s).addEventListener(
            this.eventListenerType[this.isMobile],
            function () {
              if (this.changeSelectOption === 1) {
                if (this.form.selectedSeats.includes(s)) {
                  svgDoc.getElementById(s).removeAttribute('stroke')
                  svgDoc.getElementById(s).style.fill =
                    this.venueAvailability[s].ticketAssigned == false
                      ? '#BD0202'
                      : this.venueAvailability[s].wasUnavailable ||
                        this.venueAvailability[s].state === SeatState.AVAILABLE
                      ? '#4CAF50'
                      : '#D9D9D9'

                  this.form.selectedSeats.splice(this.form.selectedSeats.indexOf(s), 1)
                } else {
                  if (!this.venueAvailability[s]) {
                    this.venueAvailability[s] = { ticketAssigned: false }
                  }
                  if (
                    this.form.selectedSeats.length == this.form.initialQuantity &&
                    (!this.venueAvailability[s].wasUnavailable ||
                      !this.venueAvailability[s].ticketAssigned ||
                      this.venueAvailability[s].state === SeatState.AVAILABLE)
                  ) {
                    return
                  }
                  this.addWhiteColorOnElementSelect(s, svgDoc)
                  this.form.selectedSeats.push(s)
                }
              }
              if (this.changeSelectOption === 2) {
                const row = this.getSeatRow(s)
                const section = this.getSeatSection(s)
                if (this.form.selectedSeats.includes(s)) {
                  this.form.selectedSeats = this.form.selectedSeats.filter(s => {
                    const seatRow = this.getSeatRow(s)
                    const seatSection = this.getSeatSection(s)
                    if (seatRow === row && seatSection === section) {
                      svgDoc.getElementById(s).removeAttribute('stroke')
                      svgDoc.getElementById(s).style.fill = '#4CAF50'
                    }

                    return (seatSection !== section && seatRow === row) || seatRow !== row
                  })
                } else {
                  let newSelectedSeats = [
                    ...this.selectedVenue.seats.filter(s => {
                      const seatRow = this.getSeatRow(s)
                      const seatSection = this.getSeatSection(s)
                      if (seatRow === row && seatSection === section) {
                        return (
                          seatRow === row &&
                          !this.form.selectedSeats.includes(s) &&
                          ((this.venueAvailability[s] &&
                            this.venueAvailability[s].state === SeatState.AVAILABLE) ||
                            !this.venueAvailability[s])
                        )
                      }
                    }),
                  ]
                  this.form.selectedSeats = [...this.form.selectedSeats, ...newSelectedSeats]
                  newSelectedSeats.map(rs => this.addWhiteColorOnElementSelect(rs, svgDoc))
                }
              }
            }.bind(this),
          )
        }
      })
    },
    getSeatRow(s) {
      return s.split('_').find(seatRow => seatRow.includes('Row-'))
    },
    getSeatSection(s) {
      return s.split('_').find(seatRow => seatRow.includes('Section-'))
    },
    colorSeat(svgDoc, s, firstInit = false) {
      if (
        (!this.venueAvailability[s] || this.venueAvailability[s].state === undefined) &&
        firstInit
      ) {
        this.venueAvailability[s] = {}
        this.venueAvailability[s].wasUnavailable = true

        if (this.form.selectedSeats.includes(s)) this.addWhiteColorOnElementSelect(s, svgDoc)
        else svgDoc.getElementById(s).style.fill = '#4CAF50'
      }

      if (
        this.venueAvailability[s].state === SeatState.HOLD ||
        this.venueAvailability[s].state === SeatState.SOLD ||
        this.venueAvailability[s].state === SeatState.DISABLED
      ) {
        svgDoc.getElementById(s).style.fill = '#D9D9D9'
      } else {
        if (this.form.selectedSeats.includes(s)) this.addWhiteColorOnElementSelect(s, svgDoc)
        else svgDoc.getElementById(s).style.fill = '#4CAF50'
      }
    },
    addWhiteColorOnElementSelect(seatId, svgDoc) {
      const selectedElement = svgDoc.getElementById(seatId)
      let strokeWidth = 2
      if (svgDoc.getElementById(seatId).hasAttribute('r')) {
        strokeWidth = Number(svgDoc.getElementById(seatId).getAttribute('r')) * 0.4
      }
      selectedElement.style.fill = 'white'
      selectedElement.setAttribute('stroke', '#333333')
      selectedElement.setAttribute('stroke-width', strokeWidth)
    },
    hammerInit: function () {
      let eventsHandler
      eventsHandler = {
        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
        init: function (options) {
          let instance = options.instance,
            initialScale = 1,
            pannedX = 0,
            pannedY = 0
          this.hammer = Hammer(options.svgElement, {
            inputClass: Hammer.SUPPORT_POINTER_EVENTS
              ? Hammer.PointerEventInput
              : Hammer.TouchInput,
          })
          this.hammer.get('pinch').set({
            enable: true,
          })
          this.hammer.on('doubletap', function () {
            instance.zoomIn()
          })
          this.hammer.on('panstart panmove', function (ev) {
            if (ev.type === 'panstart') {
              pannedX = 0
              pannedY = 0
            }
            instance.panBy({
              x: ev.deltaX - pannedX,
              y: ev.deltaY - pannedY,
            })
            pannedX = ev.deltaX
            pannedY = ev.deltaY
          })
          this.hammer.on('pinchstart pinchmove', function (ev) {
            if (ev.type === 'pinchstart') {
              initialScale = instance.getZoom()
              instance.zoomAtPoint(initialScale * ev.scale, {
                x: ev.center.x,
                y: ev.center.y,
              })
            }
            instance.zoomAtPoint(initialScale * ev.scale, {
              x: ev.center.x,
              y: ev.center.y,
            })
          })
          options.svgElement.addEventListener('touchmove', function (e) {
            e.preventDefault()
          })
        },
        destroy: function () {
          this.hammer.destroy()
        },
      }
      window.panZoom = svgPanZoom('#svgfile', {
        zoomEnabled: true,
        controlIconsEnabled: true,
        maxZoom: 3,
        fit: 1,
        center: 1,
        customEventsHandler: eventsHandler,
      })
    },
  },
}
</script>

<style scoped>
.floor-plan {
  width: 42.75rem;
  height: fit-content;
  border: 2px solid #f5f5f5;
  border-radius: 8px;
}

.floor-plan-title {
  width: 100%;
  height: 3.5rem;
  background: #f5f5f5;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #666666;
  display: flex;
  align-items: center;
  text-indent: 1.5rem;
}

.lower-container {
  display: flex;
  margin-top: 1.5rem;
  column-gap: 1.5rem;
  width: 700px;
}

#spinner-container {
  height: 600px;
}

#spinner-svg-wrapper {
  height: 200px;
  overflow: hidden;
  padding: 1rem;
}

.seat-state-wrapper {
  width: fit-content;
  display: flex;
  border-top: 2px solid #f5f5f5;
  padding: 1rem;
  column-gap: 0.5rem;
  gap: 6px;
}

.state-logo {
  height: 1rem;
  width: 1rem;
  align-self: center;
  background: black;
  border-radius: 100rem;
}

span {
  color: var(--Grey-10, #666);
}

.seat-state {
  display: flex;
  align-items: flex-start;
  column-gap: 0.5rem;
  padding: 0.2rem 0.5rem;
}

.count {
  color: #0277bd;
  display: flex;
  padding: 2px;
  margin: 0;
  align-items: center;
  gap: 8px;
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: normal;
  border-radius: 2px;
  font-weight: 400;
  line-height: 150%;
}

.radio-buttons-container {
  display: flex;
  margin: 16px 20px 16px;
}

@media screen and (max-width: 1012px) {
  .lower-container {
    flex-direction: column;
    width: 100%;
  }

  .floor-plan {
    width: unset;
    max-width: 42.75rem !important;
  }

  .radio-buttons-container {
    flex-wrap: wrap;
    row-gap: 1rem;
  }
}
</style>
